module.exports = __webpack_public_path__ + "static/media/warehouse.61e4fda0.svg";